/*
 * "Back to ..." link on product pages.
 *
 * Product URLs stay /products/<handle> (collection-product URLs are off for SEO),
 * so the page has no server-side knowledge of where the shopper came from. This
 * script remembers the last collection or search page they were on, in
 * sessionStorage, and offers a way back only when the referrer proves they came
 * straight from it.
 *
 * The URL is captured again on pagehide because the collection filters rewrite
 * the URL with history.pushState (assets/facets.js). Storing only on load would
 * remember the unfiltered URL and the referrer would never match.
 *
 * Clicking calls history.back() so filters, sort order and scroll position are
 * restored by the browser rather than re-requested.
 */
(function () {
  var KEY = "prb:last-listing";
  var path = window.location.pathname;
  var isProductUrl = path.indexOf("/products/") !== -1;
  var isSearch = !isProductUrl && path.indexOf("/search") === 0;
  var isCollection = !isProductUrl && path.indexOf("/collections/") === 0;

  function listingTitle() {
    if (isSearch) return "search results";
    var heading = document.querySelector(
      ".section-main-collection-banner .page-hero-heading, .section-main-collection-banner .collection-hero-banner-heading"
    );
    if (heading && heading.textContent.trim()) return heading.textContent.trim();
    var crumbs = document.querySelectorAll(".breadcrumb .breadcrumb-item");
    if (crumbs.length) {
      var last = crumbs[crumbs.length - 1].textContent.trim();
      if (last) return last;
    }
    return "";
  }

  function remember() {
    try {
      sessionStorage.setItem(
        KEY,
        JSON.stringify({
          url: window.location.href,
          title: listingTitle(),
          type: isSearch ? "search" : "collection"
        })
      );
    } catch (error) {
      /* private mode, blocked storage: the link simply never appears */
    }
  }

  if (isSearch || isCollection) {
    remember();
    window.addEventListener("pagehide", remember);
    return;
  }

  var link = document.querySelector("[data-product-back-link]");
  if (!link) return;

  var referrer = document.referrer;
  if (!referrer) return;

  var stored;
  try {
    stored = JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch (error) {
    return;
  }
  if (!stored || !stored.url) return;

  var here, there;
  try {
    here = new URL(referrer);
    there = new URL(stored.url);
  } catch (error) {
    return;
  }

  if (here.origin !== window.location.origin) return;
  if (here.href !== there.href) return;

  var text = link.querySelector("[data-product-back-link-text]");
  if (text) {
    if (stored.type === "search") {
      text.textContent = "Back to search results";
    } else if (stored.title) {
      text.textContent = "Back to " + stored.title;
    } else {
      text.textContent = "Back to results";
    }
  }

  link.setAttribute("href", stored.url);
  link.hidden = false;

  link.addEventListener("click", function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.history.back();
  });
})();
